import { _ } from "vue-underscore";

const tribuneERE = {
  tribunePrefix: "ERE",
  seats: [..._.range(95, 0, -1)],
  rows: [
    {
      name: 5,
      items: [...Array(11).fill("empty"), ..._.range(83, 96, +1)]
    },
    {
      name: "stairs",
      items: ["stairs", ...Array(23).fill("empty")]
    },
    { name: 4, items: [...Array(11).fill("empty"), ..._.range(70, 83, +1)] },
    {
      name: "stairs",
      items: ["stairs", ...Array(23).fill("empty")]
    },
    { name: 3, items: ["empty", ..._.range(47, 70, +1)] },
    {
      name: "stairs",
      items: ["stairs", ...Array(23).fill("empty")]
    },
    { name: 2, items: ["empty", ..._.range(24, 47, +1)] },
    {
      name: "stairs",
      items: ["stairs", ...Array(23).fill("empty")]
    },
    { name: 1, items: ["empty", ..._.range(1, 24, +1)] }
  ]
};

export default tribuneERE;
